module.exports = __webpack_public_path__ + "static/media/page4.484d0dd0.png";